import { motion } from "framer-motion";
import { ClipboardList, HeartHandshake, LifeBuoy } from "lucide-react";

const steps = [
  {
    icon: <ClipboardList size={24} />,
    title: "Clear guidance before you arrive",
    desc: "You'll know exactly what to bring, where to go and what to expect — so the first lesson feels easy, not daunting.",
  },
  {
    icon: <HeartHandshake size={24} />,
    title: "Friendly introductions and calm routines",
    desc: "Warm welcomes and familiar, gentle routines help every child settle in and feel at home in the water.",
  },
  {
    icon: <LifeBuoy size={24} />,
    title: "Support for nervous or first-time swimmers",
    desc: "Anxious or brand new to swimming? We take extra care to build trust at a pace that feels right for your child.",
  },
];

export default function WhatToExpect() {
  return (
    <section id="what-to-expect" className="py-24 md:py-32 bg-white" data-testid="what-to-expect-section">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <span className="text-sm text-[#0EA5E9] tracking-[0.2em] uppercase font-bold">What to expect</span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] leading-tight">
            Simple, supportive and positive from lesson one
          </h2>
          <p className="mt-5 text-lg text-[#334155]">
            Starting swimming lessons can feel daunting — especially if your child is nervous. We're here to make it easy every step of the way.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-[#F8FAFC] rounded-[2rem] p-8 md:p-10 border border-slate-100 hover:shadow-lg transition-all duration-500"
              data-testid={`expect-card-${i}`}
            >
              <span className="grid place-items-center w-14 h-14 rounded-2xl mb-6 bg-[#0EA5E9] text-white">
                {s.icon}
              </span>
              <h3 className="font-heading text-xl font-semibold text-[#0F172A] leading-snug">{s.title}</h3>
              <p className="mt-3 text-[#334155] leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-12 font-heading text-xl md:text-2xl font-semibold text-[#0A2540] text-center">
          Every child is welcomed, supported and encouraged.
        </p>
      </div>
    </section>
  );
}
